import Spinner from './Spinner';
import Select from './Select';
import useSelect from '../hooks/useSelect';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchProviders,
  reset,
  resetProviders,
  resetSearchHasBeenMadeForThisType,
} from '../features/providers/providersSlice';
import { linkLikehoverHandlingClasses } from '../utilities/classes';

const FinderByDistance = ({ changeTab }) => {
  const minimumCharactersToSearch = 3;
  const [showMinimumCharacters, setShowMinimumCharacters] = useState(false);

  const [disableButton, setDisableButton] = useState(false);
  const loading = useSelector((state) => state.providers.loading);

  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const resetState = () => {
    setSearchParams({});
    dispatch(reset());
    dispatch(resetProviders());
  };
  const changeTabDecorated = () => {
    dispatch(resetSearchHasBeenMadeForThisType());
    resetState();
    changeTab();
  };

  const lookup = (e) => {
    e.preventDefault();
    if (disableButton) {
      return;
    }
    setSearchParams({ which: 'distance', distance, specialty, location });
  };

  useEffect(() => {
    const keyValueArray = {};

    // Iterate over the parameters and extract keys and values
    searchParams.forEach((value, key) => {
      keyValueArray[key] = value;
    });
    if (Object.keys(keyValueArray).length > 0) {
      try {
        dispatch(resetProviders());
        dispatch(fetchProviders(keyValueArray));
      } catch (e) {
        // console.error(e);
      }
    }
    maybeDisableButton();
  }, [searchParams]);

  const [location, setLocation] = useState(searchParams.get('location') ?? '');

  const setLocationWrap = (e) => {
    if (e.key === 'Enter') {
      lookup();
    }
    setLocation(e.target.value);
  };

  const {
    set: setDistance,
    selected: distance,
    options: distanceOptions,
  } = useSelect({
    options: [
      { value: 25, label: '25 miles' },
      { value: 50, label: '50 miles' },
      { value: 100, label: '100 miles' },
      { value: 150, label: '150 miles' },
    ],
    defaultValue: searchParams.get('distance') ?? 50,
  });

  const {
    set: setSpecialty,
    selected: specialty,
    options: specialtyOptions,
  } = useSelect({
    options: window?.sw?.specialties,
    defaultValue: searchParams.get('specialty') ?? '',
    blankLabel: ' All Specialties',
  });

  const maybeDisableButton = () => {
    let disabled = !(
      distance &&
      location &&
      !loading &&
      location.length >= minimumCharactersToSearch
    );
    if (
      searchParams.get('specialty') === specialty &&
      searchParams.get('location') === location &&
      searchParams.get('distance') === distance
    ) {
      disabled = true;
    }

    setDisableButton(disabled);
  };

  useEffect(() => {
    const providerLengthMet =
      !!location && location.length >= minimumCharactersToSearch;

    setShowMinimumCharacters(location && !providerLengthMet);
  }, [minimumCharactersToSearch, location, loading, searchParams]);

  useEffect(() => {
    maybeDisableButton();
  }, [distance, specialty, location, loading]);

  return (
    <form id="finder-form" onSubmit={lookup} className="w-full lg:max-w-[80%]">
      <div className="flex flex-col lg:flex-row justify-between items-center w-full gap-4">
        <div className="w-full lg:flex-1">
          <p className="text-[17px] font-bold">
            Enter Your Zip Code
          </p>

          <input
            style={{
              borderColor: showMinimumCharacters ? 'red' : '#E4E4E4',
              paddingTop: '12px',
              paddingBottom: '9px',
              borderRadius: '4px',
              paddingLeft: '10px',
              paddingRight: '10px',
            }}
            className="w-full pt-[13px] pb-[9px] px-[10px] text-[16px] font-bold rounded-[4px] border outline-none"
            type="text"
            value={location}
            onChange={(e) => setLocationWrap(e)}
            placeholder="e.g., 90210"
          />
        </div>

        <div className="w-full lg:flex-1">
          <p className="text-[17px] font-bold">
            Enter Distance
          </p>

          <Select
            className="lg:block !w-full"
            style={{
              paddingTop: '12px',
              paddingBottom: '9px',
              paddingLeft: '10px',
              paddingRight: '10px',
              borderRadius: '4px',
              borderColor: '#E4E4E4',
              fontSize: '12px',
              fontWeight: '700',
            }}
            value={distance}
            setter={setDistance}
            options={distanceOptions}
          />
        </div>
      </div>
      <p style={{ color: 'red' }} className="text-left mb-2">
        {showMinimumCharacters ? (
          <>
            Please enter at least {minimumCharactersToSearch} characters to
            search
          </>
        ) : (
          <>&nbsp;</>
        )}
      </p>
      {specialtyOptions &&
        Array.isArray(specialtyOptions) &&
        specialtyOptions.length > 2 && ( //if we have all specialties + 2 specialties, show it
          <div className="">
            <div>
              <p className="text-[17px] font-bold">
                Specialty
              </p>
              <Select
                className="lg:block hidden !w-full text-center"
                value={specialty}
                setter={setSpecialty}
                options={specialtyOptions}
              />
              <Select
                className="lg:hidden !w-full"
                value={specialty}
                setter={setSpecialty}
                options={specialtyOptions}
              />
            </div>
          </div>
        )}
      <div className="flex items-center justify-center lg:justify-start gap-[22px] mt-5">
        <button
          role="submit"
          className={`w-auto cursor-pointer o-button green block text-center px-[32px] py-[7px] `}
          disabled={disableButton}
          style={
            disableButton
              ? {
                pointerEvents: 'none',
                opacity: '60%',
              }
              : {}
          }
        >
          <span>
            Search
            {loading && <Spinner className="inline-block ml-5" />}
          </span>
        </button>

        <span
          role="button"
          style={loading ? { pointerEvents: 'none', opacity: '80%' } : {}}
          onClick={changeTabDecorated}
          className="cursor-pointer bg-transparent border border-[#61BA46] text-[#61BA46] px-[32px] py-[7px] rounded-[23px] transition-all duration-300 hover:!bg-[#61BA46] hover:!text-white"
        >
          Search by Name
        </span>
      </div>
    </form>
  );
};

export default FinderByDistance;
